/**
 * Normalización de pathname para política "siempre barra final" en rutas HTML del SPA.
 * Evita tocar segmentos que parecen ficheros estáticos (evita /file.js/).
 */

const STATIC_ASSET_EXT = /\.(ico|png|jpe?g|gif|webp|svg|css|js|mjs|json|map|txt|html|woff2?|ttf|eot)$/i;

function lastPathSegment(pathname) {
  const parts = pathname.split('/').filter(Boolean);
  return parts[parts.length - 1] ?? '';
}

/**
 * @param {string} pathname - pathname de location (empieza por /)
 * @returns {string} pathname con barra final (la raíz queda "/")
 */
export function pathnameWithTrailingSlash(pathname) {
  if (!pathname || pathname === '/') return '/';
  if (pathname.endsWith('/')) return pathname;
  if (STATIC_ASSET_EXT.test(lastPathSegment(pathname))) return pathname;
  return `${pathname}/`;
}

/**
 * Quita barras finales para comparar rutas de forma estable (/calc y /calc/ → /calc).
 * @param {string} pathname
 * @returns {string}
 */
export function stripTrailingSlash(pathname) {
  if (!pathname || pathname === '/') return '/';
  const trimmed = pathname.replace(/\/+$/, '');
  return trimmed === '' ? '/' : trimmed;
}
